<div class="modal-container">
  <div class="modal-header">
    <div class="modal-header-left">
      <span class="modal-title">{{ 'fleet.modal-add-fleet.title' | translate }}</span>
      <span class="modal-subtitle">{{ 'fleet.modal-add-fleet.subtitle' | translate }}</span>
    </div>
    <button class="close-button" (click)="closeModal()">✕</button>
  </div>

  <div class="modal-body">
    <div class="filters-row">

      <!-- Seat Filter -->
      <div class="filter-item seat select-wrapper">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ 'fleet.modal-add-fleet.seat' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedSeat"
                      (selectionChange)="applySeatFilter()"
                      [class.has-value]="selectedSeat !== undefined"
                      [placeholder]="'fleet.modal-add-fleet.selectSeat' | translate"
                      [panelClass]="'select-panel'">
          <mat-option [value]="undefined">{{ 'fleet.modal-add-fleet.selectSeat' | translate }}</mat-option>
          @for (seat of filteredSeats; track seat) {
            <mat-option [value]="seat"> {{ seat }} </mat-option>
          }
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Manufacturer Filter -->
      <div class="filter-item manufacturer select-wrapper">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'fleet.modal-add-fleet.manufacturer' | translate }}</mat-label>
          <mat-select [(ngModel)]="selectedManufacturer"
                      (selectionChange)="applyManufacturerFilter()"
                      [class.has-value]="selectedManufacturer !== undefined"
                      [placeholder]="'fleet.modal-add-fleet.selectManufacturer' | translate"
                      [panelClass]="'select-panel'">
            <mat-option [value]="undefined">{{ 'fleet.modal-add-fleet.selectManufacturer' | translate }}</mat-option>
            @for (manu of filteredManufacturers; track manu) {
              <mat-option [value]="manu">{{ manu }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Search Input + Autocomplete -->
      <div class="filter-item search-item">
        <div class="search-wrapper" (click)="$event.stopPropagation()">
          <div class="filter-item search-item">
            <app-autocomplete class="search-autocomplete"
              [placeholder]="'fleet.card.header.row1.filter.modelName' | translate"
              [label]="('fleet.card.header.row1.filter.modelName' | translate)"
              [filterCtrl]="filterCtrl"
              [filteredList$]="filteredTrucks$"
              [isLoading]="isLoading"
              [valueKey]="'id'"
              [displayKey]="'model'"
              (elementSelected)="onElementSelected($event)"/>
          </div>
        </div>
      </div>

    </div>

    <!-- Table -->
    <div class="table-container">
      @if (isTableLoading) {
        <div class="table-loading">
          <mat-progress-spinner
            mode="indeterminate"
            diameter="50">
          </mat-progress-spinner>
        </div>
      }
      @else {
        <table mat-table [dataSource]="dataSource" matSort>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>{{ 'fleet.modal-add-fleet.select' | translate }}</th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (change)="toggleSelection(row)" [checked]="selection.includes(row)"></mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="seat">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'fleet.modal-add-fleet.seat' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.seat }}</td>
          </ng-container>

          <ng-container matColumnDef="manufacturer">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'fleet.modal-add-fleet.manufacturer' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.manufacturer }}</td>
          </ng-container>

          <ng-container matColumnDef="model">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'fleet.modal-add-fleet.model' | translate }}</th>
            <td mat-cell *matCellDef="let row">{{ row.model }}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      }
    </div>

    <!-- Table Footer -->
    <div class="table-footer-row">
      <span class="selected-items">{{ 'fleet.modal-add-fleet.selectedItems' | translate:{count: selection.length} }}</span>
      <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
    </div>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <button class="cancel-button" (click)="closeModal()">{{ 'fleet.modal-add-fleet.cancel' | translate }}</button>
    <button
      class="add-button"
      [disabled]="selection.length === 0 || isSubmitting"
      (click)="addFleet()">

      @if (!isSubmitting) {
        {{ 'fleet.modal-add-fleet.addFleet' | translate:{count: selection.length} }}
      } @else {
        <mat-progress-spinner
          diameter="18"
          mode="indeterminate">
        </mat-progress-spinner>
      }
    </button>
  </div>
</div>
